import api from "./api";

export const filterBikeService = {

  // 🔍 Get filtered bikes
  getFilteredBikes: async (params = {}) => {
    try {
      const query = new URLSearchParams(params).toString();
      const response = await api.get(`/filter-bikes?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

};